import '../assets/styles/index.css'
import { createInertiaApp } from '@inertiajs/react'
import { createElement } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import PublicLayout from '../layouts/PublicLayout'

createInertiaApp({
  // Set default page title
  // see https://inertia-rails.dev/guide/title-and-meta
  //
  title: title => title ? `${title} - Turista Club` : 'Turista Club',

  // Disable progress bar
  //
  // see https://inertia-rails.dev/guide/progress-indicators
  // progress: false,

  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.jsx', { eager: true })
    const page = pages[`../pages/${name}.jsx`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.jsx'`)
    }

    // To use a default layout, import the Layout component
    // and use the following lines.
    // see https://inertia-rails.dev/guide/pages#default-layouts
    //
    // page.default.layout ||= (page) => createElement(Layout, null, page)
    page.default.layout ||= (page) => createElement(PublicLayout, null, page)

    return page
  },

  setup({ el, App, props }) {
    const hasServerMarkup = el.innerHTML.trim().length > 0

    if (el) {
      if (hasServerMarkup) {
        hydrateRoot(el, createElement(App, props))
      } else {
        createRoot(el).render(createElement(App, props))
      }
    } else {
      console.error(
        'Missing root element.\n\n' +
          'If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n' +
          'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.',
      )
    }
  },
})
